// extracted by mini-css-extract-plugin
module.exports = {"drawIcon":"DrawingItem_drawIcon__1cyfx","movingIcon":"DrawingItem_movingIcon__2t2-f","deleteIcon":"DrawingItem_deleteIcon__3hAmY"};